/**
 * @title addtocart.js: Sub-module
 * @description Associated with ProductForm.jsp
 * This JS file binds add to cart event listeners.
 * Checks if a selection is back ordered to invoke a
 * backordered modal.
 */
define([], function() {
	
	var AddMembershipNumber = {
			membershipNumberUpdateCmd    : "/AjaxMembershipNumberUpdateCmd",
			redirectTimeout : 6000,
			start : function(){
				$("#membershipNumberVerifyError").hide();
				
				$('.modal-footer').removeClass('hide');
				COSTCO.dialog.createExtDialogBox({
		    		title : AddMembershipNumberStatic.ADDMEMBERSHIPNUMBER_Title,
		    		body : COSTCO.util.tmpl('tmpl_addmembernumber_modal',{}),
		    		primary : AddMembershipNumberStatic.CONTINUE,
		    		primary_event : function(){COSTCO.AddMembershipNumber.updateMembershipNumber();},
		    		secondary : AddMembershipNumberStatic.CANCEL
		    	});
				
				$("#membershipNumberToAdd").keypress(function(){$("#membershipNumberToAddError").hide();});

			},
			submitRequest : function (urlWithParams, successFunction){
				$.ajax({
					type: 'POST',
					url: urlWithParams,
					dataType: 'json',
					success: function(data) {
						successFunction(data);
					},
					timeout: 6000,
					error: function(x, t, m) {
		        		if(t==="timeout") {
		        			console.log("Error timeout.");
		        		} else {
		        			console.log("Error");
		        		}
		    		}
				});
			},
			costcoMembershipNumber: function(value) {
				return /^\d{12,16}$/.test(value);
			},
			updateMembershipNumber : function(){
				if(COSTCO.AddMembershipNumber.costcoMembershipNumber($("#membershipNumberToAdd").val())){
					
					var url = COSTCO.AddMembershipNumber.membershipNumberUpdateCmd + "?membershipNumber=" + $("#membershipNumberToAdd").val();
					COSTCO.AddMembershipNumber.submitRequest(url, COSTCO.AddMembershipNumber.reload);
				} else {
					$("#membershipNumberToAddError").show();
				}
			},
			reload : function(data){
				if(data.success){
					location.reload();
				} else {
					$("#membershipNumberToAddError").show();
				}
					
			}
			
	}
    if(typeof window.COSTCO == 'undefined'){
        window.COSTCO = new Object();
    }
    window.COSTCO.AddMembershipNumber = AddMembershipNumber;
    
    return AddMembershipNumber;
});


// WEBPACK FOOTER //
// ./js/product/addMemberNumber.js